var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('van-image',{attrs:{"width":"100%","height":"150","fit":"cover","src":"https://elite-mini-program.oss-cn-hangzhou.aliyuncs.com/dingtalk-file/bg-wide.png"}}),_c('div',{staticClass:"position",on:{"click":_vm.clearToken}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }